/**
 * Owl Carousel Slider
 */



export default function BOT_Slider() {

    const selectors = {
        carousel: ".owl-carousel"
    };

    this.init = () => {
        createImageGallery()
        createWhatPouring()
        // createC7Recomendation()
        jQuery(window).on("resize", function () {
            createWhatPouring()
        })
    };
    const createImageGallery = () => {
        jQuery(document).ready(function ($) {
            if ($(".bot__image_gallery").length) {
                $(".bot__image_gallery").each(function () {
                    const el = $(this);

                    el.find(".bot__image_gallery-content").owlCarousel({
                        autoplay: false,
                        // autoplayTimeout: 7000,
                        dots: true,
                        loop: true,
                        // autoWidth: true,
                        center: true,
                        responsive: {
                            0: {
                                items: 1,
                                // center: true
                            },
                            800: {
                                items: 2
                            },
                            1440: {
                                items: 3
                            }
                        },

                        nav: true,
                        navText: [
                            `<div><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 1L6 12L17 23C17 23 14.97 16.455 15 12C15.0291 7.6877 17 1 17 1Z" fill="#EFECEA"/>
                            </svg></div>
                            `,
                            `<div><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 1L19 12L8 23C8 23 10.03 16.455 10 12C9.97095 7.6877 8 1 8 1Z" fill="#EFECEA"/>
                            </svg></div>
                            `,
                        ],
                        // smartSpeed: 700,
                    });
                })
            }
        });
    }
    const createWhatPouring = () => {
        jQuery(document).ready(function ($) {
            if ($(".bot__whats_pouring").length) {
                $(".bot__whats_pouring").each(function () {
                    const widthWindow = jQuery(window).width()
                    const el = $(this);
                    if (widthWindow >= 1440) {
                        el.find(".bot__whats_pouring-content .list-products").removeClass("owl-carousel")
                        el.find(".bot__whats_pouring-content .list-products").owlCarousel("destroy")
                        return
                    }
                    el.find(".bot__whats_pouring-content .list-products").addClass("owl-carousel")
                    el.find(".bot__whats_pouring-content .list-products").owlCarousel({
                        autoplay: false,
                        dots: true,
                        loop: false,
                        responsive: {
                            0: {
                                items: 1
                            },
                            800: {
                                items: 3,
                                margin: 32,
                            }
                        },
                        nav: true,
                        navText: [
                            `<div><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1L6 12L17 23C17 23 14.97 16.455 15 12C15.0291 7.6877 17 1 17 1Z" fill="#20282B"/>
                        </svg></div>
                        `,
                            `<div><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 1L19 12L8 23C8 23 10.03 16.455 10 12C9.97095 7.6877 8 1 8 1Z" fill="#20282B"/>
                        </svg></div>
                        `,
                        ],
                    });
                })
            }
        })
    }
}
